<template>
	<app tabbar>
		<scroll-list ref="list" class="notice">
			<template v-slot="{data}">
				<div class="item" @click="navigateTo('/notice_detail', {id: data.id})">
					<p>{{data.title}}</p>
					<span>{{data.create_date}}</span>
				</div>
			</template>
		</scroll-list>
	</app>
</template>

<script>
	export default {
		mounted() {
			this.$refs.list.load({
				url: '/announcement/list'
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.notice {
		margin: .24rem .24rem 0;
		
		>>> .item {
			padding: .3rem .3rem;
			background: #fff;
		
			&:nth-child(n+2) {
				border-top: 1px solid #eee;
			}
			
			p {
				margin-bottom: .16rem;
				line-height: .48rem;
				font-size: .32rem;
				color: #1F1F1F;
				
				elder({
					line-height: .66rem,
					font-size: .46rem
				})
			}
			
			span {
				font-size: .26rem;
				color: #999;
				
				elder({
					font-size: .38rem
				})
			}
		}
	}
</style>
